import { post } from "../services/api";

export const changeCustomerPassword = (post_data) => {
    return (dispatch) => {
        return post("userpanel/changepassword", post_data).then(({ data }) => {
            return data;
        });
    };
};

export const userLogin = (requestData) => { }; // Placeholder for future implementation

export const userpanelDashboard = (parms) => {
    return (dispatch) => {
        return post("userpanel/dashboard", parms).then(({ data }) => {
            return data;
        });
    };
};
